import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Re-runs invite processing when the user leaves a deferred zone (call, error page)
 * and returns to the app shell. pathname is included because navigation to shell is
 * what ends deferral — not every isDeferred flip is guaranteed to re-trigger hook effects
 * on the same render pass as the route change.
 */
const useInviteDeferFlush = (isDeferred: boolean, onFlush: () => void): void => {
  const { pathname } = useLocation();
  const wasDeferredRef = useRef(isDeferred);

  useLayoutEffect(() => {
    if (wasDeferredRef.current && !isDeferred) {
      onFlush();
    }
    wasDeferredRef.current = isDeferred;
  }, [isDeferred, pathname, onFlush]);
};

export default useInviteDeferFlush;
